module.exports = __webpack_public_path__ + "img/54.a39fad78.png";